import { render, staticRenderFns } from "./userProtocol.vue?vue&type=template&id=fef42ad8&scoped=true&"
import script from "./userProtocol.vue?vue&type=script&lang=js&"
export * from "./userProtocol.vue?vue&type=script&lang=js&"
import style0 from "./userProtocol.vue?vue&type=style&index=0&id=fef42ad8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef42ad8",
  null
  
)

export default component.exports